// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-22X0"};